export default {
  1: ' 0px 4px 4px rgba(0, 0, 0, 0.1)',
  2: '0px 2px 12px rgba(67, 60, 60, 0.15)',
  3: '0px 4px 14px 1px rgba(67, 60, 60, 0.2)',
  4: '0px 5px 20px 2px rgba(67, 60, 60, 0.2)',
  5: '0px 5px 24px 2px rgba(71, 68, 68, 0.3)',
  6: '0px 4px 4px rgba(0, 0, 0, 0.6)',
  7: '0px 2px 12px rgba(0, 0, 0, 0.65)',
  8: '0px 4px 14px 1px rgba(0, 0, 0, 0.65)',
  9: '0px 5px 20px 2px rgba(0, 0, 0, 0.65)',
  10: '0px 5px 24px 2px rgba(0, 0, 0, 0.8)',
};
